import { Transaction } from './transaction';

export class Rsvp extends Transaction {
  eventRsvpId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rsvp.ts